export type FlattenIndicatorOutputsOptions = {
  /** Parent chevron shell when detail lives in Arrow (dim_item_data omitted). */
  arrowParentShell?: boolean;
};

/**
 * Flattens a block output / add_indicator row into parent (+ optional chevron children)
 * for the dimensional data table (matches FetchBlockOutputsV2 Redux shape).
 */
export default function flattenIndicatorOutputsForTable(
  object: Record<string, any>,
  options: FlattenIndicatorOutputsOptions = {},
): any[] {
  const flattened: any[] = [];
  const hasNestedDim = Boolean(object?.dim_item_data);
  const arrowParentShell =
    options.arrowParentShell &&
    !hasNestedDim &&
    Array.isArray(object?.dims) &&
    object.dims.length > 0;

  if (hasNestedDim || arrowParentShell) {
    flattened.push({ ...object, chevronType: 'parent' });
  } else {
    flattened.push(object);
  }

  if (!object?.dim_item_data) return flattened;

  const rawDimItems = Array.isArray(object.dim_item_data)
    ? object.dim_item_data
    : Object.values(object.dim_item_data || {});

  // Sort by dimension item id ascending to match the order defined in the Dimensions page.
  const dimItems = [...rawDimItems].sort(
    (a: any, b: any) => Number(a?.id ?? 0) - Number(b?.id ?? 0),
  );

  dimItems.forEach((dataObject: any, index: number) => {
    flattened.push({
      ...dataObject,
      id: dataObject?.id ?? `${object?.id ?? 'parent'}__${dataObject?.name ?? index}`,
      type: object?.type,
      chevronType: 'child',
      total_values: dataObject?.value ?? dataObject?.total_values,
      indicatorId: object?.id,
      parentId: object?.id,
    });
  });

  return flattened;
}
